// extracted by mini-css-extract-plugin
export default {"list":"DyeDisplayList_list__Baxfk","container":"DyeDisplayList_container__Tfri9","searchInput":"DyeDisplayList_searchInput__x1fU2"};